import SalesForceApiService from '@/api/salesforce_api_service';

export default {
  getSfLead(args) {
    const { id } = args;
    return new SalesForceApiService().get(`/user/salesforce/sf_leads/${id}`);
  },
};
